export const OPTHINES = {
  voteName: '2019poject/2019finance',
  mustSearch: 'Button',
  buttonBg: '#f4a842',
  tickets: true,
  hasVoteButton: {
    text: '点赞',
    themeColor: '#990708',
    textColor: '#fff',
  },
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  checkBox: true,
  themeColor: {
    activeBgColor: 'rgb(153, 7, 8)',
    inactiveBgColor: 'rgb(241, 214, 8)',
  },
  tabs: [
    {
      tabName: '上游金融榜',
      tabPath: '/2019CQJR/first',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019CQJR/second',
    },
    {
      tabName: '活动规则',
      tabPath: '/2019CQJR/third',
    },
  ],
};
